// Le code du template utilise `Phaser` comme variable GLOBALE (ex: `extends Phaser.Scene`).
// Avec Rollup (IIFE) ce global existait implicitement ; avec Vite (ESM) il faut le poser nous-mêmes.
// Ce module est importé EN PREMIER par game.ts : il s'évalue avant toute classe qui étend Phaser.Scene,
// donc `globalThis.Phaser` est prêt à temps. Évite de réécrire chaque fichier.
import Phaser from 'phaser'

;(globalThis as any).Phaser = Phaser

export default Phaser
